import { useState } from "react";
import { Upload, Check } from "lucide-react";
import { Button } from "../ui/button";

export const FileField = ({ kind, value, onChange, call, testId }) => {
  const [busy, setBusy] = useState(false);
  const [name, setName] = useState("");
  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setBusy(true);
    try {
      const r = await call("post", `/admin/upload?kind=${kind}`, fd);
      setName(r.filename);
      onChange(r.path);
    } catch { /* toast shown */ } finally { setBusy(false); e.target.value = ""; }
  };
  return (
    <div className="flex items-center gap-3">
      <Button type="button" variant="outline" disabled={busy} className="rounded-full" asChild>
        <label className="cursor-pointer">
          <Upload className="mr-2 h-4 w-4" /> {busy ? "Envoi…" : kind === "pdf" ? "Choisir le PDF" : kind === "audio" ? "Choisir le MP3" : "Choisir l'image"}
          <input type="file" className="hidden" accept={kind === "pdf" ? "application/pdf" : kind === "audio" ? "audio/mpeg,.mp3" : "image/png,image/jpeg,image/webp"} onChange={pick} data-testid={testId} />
        </label>
      </Button>
      {value && <span className="flex items-center gap-1 truncate text-sm text-[#3a9a10]"><Check className="h-4 w-4" /> {name || "Fichier enregistré"}</span>}
    </div>
  );
};
